import { render, staticRenderFns } from "./MdrlEditMain.vue?vue&type=template&id=54ed2b54&scoped=true&"
import script from "./MdrlEditMain.vue?vue&type=script&lang=js&"
export * from "./MdrlEditMain.vue?vue&type=script&lang=js&"
import style0 from "./MdrlEditMain.vue?vue&type=style&index=0&id=54ed2b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed2b54",
  null
  
)

export default component.exports